import { BaseModel } from '../../../data/models'
import { BasePrompt } from '../'

export class Form<T extends BaseModel> {
  public prompts: Array<BasePrompt<any>> = []
  public title: string = 'Form'

  public constructor(public model: T) {}

  public getPrompt<C extends BasePrompt<any>>(key: string): C {
    return this.prompts.filter((prompt) => prompt.key === key)[0] as C
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/forms/models/form/form.ts